export default "__VITE_ASSET__9b264f71__"